import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    requiredBoolean,
    requiredNumber,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createInventoryProductsAddSchema = () =>
    z.object({
        id: requiredUuid(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
        product_id: requiredUuid(),
        quantity: requiredNumber(),
        favourite: requiredBoolean(),
        user_id: requiredUuid(),
        organisation_id: requiredUuid(),
    });

export const createInventoryProductsUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createInventoryProductsAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.inventory_products,
    );

export const createInventoryProductsDeleteSchema = () => createDeleteSchema();

export const createInventoryProductsSchemas = () => ({
    add: createInventoryProductsAddSchema(),
    update: createInventoryProductsUpdateSchema(),
    delete: createInventoryProductsDeleteSchema(),
});
